module.exports = __webpack_public_path__ + "static/img/cont1903.24892eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1903.jpg
// module id = MBPZ
// module chunks = 0